import { UrlMatchResult, UrlSegment } from '@angular/router';
import { getVariantCodeFromUrl } from '@app/helpers';

/**
 * Matches pattern `p/{productName}--:productCode`
 * @param segments
 */
export function customProductUrlMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  const length = segments.length >= 2;
  if (length && segments[0].path === 'p') {
    let productCode = segments[1].path.split(/-{2,}/).slice(-1)[0];
    if (segments[1].path.includes('#')) {
      productCode = getVariantCodeFromUrl(segments[1].path);
    }
    return {
      consumed: segments,
      posParams: { productCode: new UrlSegment(productCode, {}) },
    };
  }
  return null;
}
